// FAQ Accordion - ES Module
class FAQAccordion {
  constructor(container) {
    this.container = container;
    this.items = container.querySelectorAll('.faq-item');
    this.exploreAllButton = container.querySelector('[data-faq-explore-all]');
    this.hiddenItems = container.querySelectorAll('.faq-item--hidden');
    this.showAllOpen = container.getAttribute('data-show-all-open') === 'true';
    this.init();
  }

  init() {
    this.items.forEach((item) => {
      const header = item.querySelector('[data-faq-trigger]');
      const content = item.querySelector('.faq-item-content');
      const isOpen = header.getAttribute('aria-expanded') === 'true';

      // Initial state
      item.setAttribute('data-open', isOpen);
      if (isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }

      if (!this.showAllOpen) {
        // Toggle click
        header.addEventListener('click', () => this.toggleItem(item));

        // Keyboard toggle
        header.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.toggleItem(item);
          }
        });
      }

      // Escape closes and returns focus
      content.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeItem(item);
          header.focus();
        }
      });
    });

    if (this.showAllOpen) {
      this.openAllItems();
      return;
    }

    // Initialize "Explore all" button if it exists
    if (this.exploreAllButton && this.hiddenItems.length > 0) {
      this.exploreAllButton.addEventListener('click', () => this.toggleExploreAll());
      this.exploreAllButton.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleExploreAll();
        }
      });
    }
  }

  closeAllExcept(currentItem) {
  this.items.forEach((item) => {
    if (item !== currentItem) {
      this.closeItem(item);
    }
  });
}


  toggleExploreAll() {
    const isExpanded = this.exploreAllButton.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      this.collapseAll();
    } else {
      this.expandAll();
    }
  }

  openAllItems() {
    this.items.forEach((item) => {
      const header = item.querySelector('[data-faq-trigger]');
      const content = item.querySelector('.faq-item-content');

      item.setAttribute('data-open', 'true');
      header.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
      content.style.maxHeight = content.scrollHeight + 'px';
    });
  }

  expandAll() {
    this.container.setAttribute('data-expanded', 'true');
    this.exploreAllButton.setAttribute('aria-expanded', 'true');
    
    // Update button text
    const textElement = this.exploreAllButton.querySelector('[data-faq-explore-all-text]');
    if (textElement) {
      textElement.textContent = 'Show less';
    }
    
    // Reveal hidden items with staggered animation
    this.hiddenItems.forEach((item, index) => {
      setTimeout(() => {
        item.style.display = 'block';
        // Trigger reflow for animation
        requestAnimationFrame(() => {
          item.classList.remove('faq-item--hidden');
        });
      }, index * 50); // Stagger the animation slightly
    });
  }

  collapseAll() {
    this.container.setAttribute('data-expanded', 'false');
    this.exploreAllButton.setAttribute('aria-expanded', 'false');
    
    // Update button text
    const textElement = this.exploreAllButton.querySelector('[data-faq-explore-all-text]');
    if (textElement) {
      textElement.textContent = 'Explore all';
    }
    
    // Hide items
    this.hiddenItems.forEach((item) => {
      item.classList.add('faq-item--hidden');
      // Wait for animation to complete before hiding
      setTimeout(() => {
        if (this.container.getAttribute('data-expanded') === 'false') {
          item.style.display = 'none';
        }
      }, 300); // Match CSS animation duration
    });
  }

  toggleItem(item) {
    const isOpen = item.getAttribute('data-open') === 'true';
    if (isOpen) this.closeItem(item);
    else this.openItem(item);
  }

openItem(item) {
  // NEW: Close all others first
  this.closeAllExcept(item);

  const header = item.querySelector('[data-faq-trigger]');
  const content = item.querySelector('.faq-item-content');
  item.setAttribute('data-open', 'true');
  header.setAttribute('aria-expanded', 'true');
  content.setAttribute('aria-hidden', 'false');
  content.style.maxHeight = content.scrollHeight + 'px';
}


  closeItem(item) {
    const header = item.querySelector('[data-faq-trigger]');
    const content = item.querySelector('.faq-item-content');
    item.setAttribute('data-open', 'false');
    header.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    content.style.maxHeight = '0';
  }
}

// Auto-init
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('[data-faq-accordion]');
  containers.forEach((el) => new FAQAccordion(el));
});

export {}; // Ensures module scope


